<template>
  <div>
    <div class="enterpriseBox">
      <div class="enterpriseMains">
        <breadcrumb>
          <el-breadcrumb slot="breadcrumb" separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path:'/personal/users/home' }">个人中心</el-breadcrumb-item>
            <el-breadcrumb-item>企业认证</el-breadcrumb-item>
          </el-breadcrumb>
        </breadcrumb>
       <div class="threeSteps">
          <ul>
            <!-- <li>
              <span class="stepWalk"></span>
            </li>
            <li>
              <div class="enterpriseStep stepWalk">
                <span></span>
              </div>
              <p class="stepWalk">企业信息填写</p>
            </li> -->
            <li>
              <span  class="stepWalk"></span>
            </li>
            <li>
              <div class="enterpriseStep stepWalk">
                <span></span>
              </div>
              <p>补充资料填写</p>
            </li>
            <li>
              <span></span>
            </li>
            <li>
              <div class="enterpriseStep">
                <span></span>
              </div>
              <p>完成</p>
            </li>
            <li>
              <span></span>
            </li>
          </ul>
        </div>
        <div class="uploadFilesBox" v-show="uploadFirst" id="uploadFilesBox">
          <div class="filesHead ft18">
            <ul>
              <li></li>
              <li>基本信息</li>
            </ul>
          </div>
          <div class="fillInBox ft14">
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item label="机构名称：" prop="enterpriseName">
                <el-input v-model="ruleForm.enterpriseName" placeholder="请输入机构名称"></el-input>
              </el-form-item>
              <el-form-item label="所属行业：" prop="enterpriseIndustryId">
                <el-select v-model="ruleForm.enterpriseIndustryId" placeholder="请选择">
                  <el-option
                    v-for="item in options"
                    :label="item.name"
                    :value="item.id"
                    :key="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="机构类型：" prop="enterpriseCategoryId">
                <el-select
                  v-model="ruleForm.enterpriseCategoryId"
                  placeholder="请选择"
                  @change="selectedChange"
                >
                  <el-option
                    v-for="item in units"
                    :label="item.name"
                    :value="item.id"
                    :key="item.id"
                  ></el-option>
                </el-select>
                <p class="termination" v-if="showCheck">
                  <el-checkbox @change="changeChecked" v-model="checked">三证合一</el-checkbox>
                </p>
              </el-form-item>
              <el-form-item label="组织机构代码：" prop="ZZJG" v-if="!checked">
                <el-input v-model="ruleForm.ZZJG" placeholder="请输入"></el-input>
              </el-form-item>

              <el-form-item label=" 法人证书：" prop="permit" v-if="ruleForm.enterpriseCategoryId == 2">
                <el-input v-model="ruleForm.permit" placeholder="请输入"></el-input>
              </el-form-item>

              <el-form-item label="许可证号：" prop="permit" v-if="ruleForm.enterpriseCategoryId == 5">
                <el-input v-model="ruleForm.permit" placeholder="请输入"></el-input>
              </el-form-item>

              <el-form-item
                label="营业执照注册号："
                prop="licenseCode"
                v-if="ruleForm.enterpriseCategoryId == 4"
              >
                <el-input v-model="ruleForm.licenseCode" placeholder="请输入"></el-input>
              </el-form-item>

              <el-form-item label="联系地址：" prop="address">
                <area-cascader
                  :level="1"
                  :type="'text'"
                  v-model="ruleForm.address"
                  :data="pcaa"
                  v-if="cityshow"
                  placeholder="请选择地区"
                  @change="restValid"
                ></area-cascader>
              </el-form-item>
              <el-form-item label prop="enterpriseAddress">
                <el-input v-model="ruleForm.enterpriseAddress" placeholder="请输入详细的地址"></el-input>
              </el-form-item>
              <el-form-item label="邮政编码：" prop="postCode">
                <el-input v-model="ruleForm.postCode" placeholder="请输入邮政编码"></el-input>
              </el-form-item>
              <el-form-item label="固定电话：" prop="enterprisePhone">
                <el-input v-model="ruleForm.enterprisePhone" placeholder="请输入固定电话"></el-input>
              </el-form-item>
              <el-form-item label="传真电话：" prop="enterpriseFax">
                <el-input v-model="ruleForm.enterpriseFax" placeholder="请输入传真电话"></el-input>
              </el-form-item>
              <el-form-item style="display:none">
                <el-button type="primary" class="subMit" @click="submitForm('ruleForm')">提交</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="uploadFilesBox" v-show="uploadFirst">
          <div class="filesHead ft18">
            <ul>
              <li></li>
              <li>上传文件</li>
              <!-- <li class="ft12">
                <span class="ft14">*</span>温馨提示：上传单张图片大小应小于5M，营业执照副本可支持JPEG、JPG、PNG格式
              </li>-->
            </ul>
          </div>
          <div class="filesContent">
            <dl class="uploadItem" v-if="!checked">
              <dt v-loading="imgUrlJGLd">
                <img v-if="imgUrlJG " :src="imgUrlJG" />
                <img v-if="!imgUrlJG" src="../../../assets/images/enterprise/zzjgdmz_img.png" />
              </dt>
              <dd>
                <el-upload
                  class="uploadBox"
                  :show-file-list="false"
                  :action="datas"
                  :on-progress="handlerPress()"
                  :on-success="handlerSuccessUploadImgUrlJG"
                  :before-upload="beforeUploadImgUrlJG"
                  :headers="uploadHeader()"
                  :on-error="handlerErrorUploadImgUrlJG"
                >
                  <div class="uploadButton">上传组织机构代码证</div>
                </el-upload>
                <div class="imgRuleDscp">原件扫描上传，图片大小不超过2M，文件格式为jpg、jpeg、png</div>
                <div class="seeImgEx" @click="showExp('imgUrlJG')">查看样例</div>
              </dd>
            </dl>
            <dl class="uploadItem" v-if="ruleForm.enterpriseCategoryId == 2">
              <dt v-loading="imgUrlSYXKLd">
                <!-- 事业单位许可证 -->
                <img v-if="!imgUrlSYXK" src="../../../assets/images/enterprise/sydwfrzs_img.png" />
                <img v-if="imgUrlSYXK" :src="imgUrlSYXK" />
              </dt>
              <dd>
                <el-upload
                  class="uploadBox"
                  :show-file-list="false"
                  :action="datas"
                  :on-success="handlerSuccessUploadImgUrlSYXK"
                  :before-upload="beforeUploadImgUrlSYXK"
                  :headers="uploadHeader()"
                  :on-error="handlerErrorUploadImgUrlSYXK"
                >
                  <div class="uploadButton">上传法人证书</div>
                </el-upload>
                <div class="imgRuleDscp">原件扫描上传，图片大小不超过2M，文件格式为jpg、jpeg、png</div>
                <div class="seeImgEx" @click="showExp('imgUrlSYXK')">查看样例</div>
              </dd>
            </dl>
            <dl class="uploadItem" v-if="ruleForm.enterpriseCategoryId == 5">
              <dt v-loading="imgUrlLSXKLd">
                <!-- 律师许可证 -->
                <img v-if="!imgUrlLSXK" src="../../../assets/images/enterprise/lssws_img.png" />
                <img v-if="imgUrlLSXK" :src="imgUrlLSXK" />
              </dt>
              <dd>
                <el-upload
                  class="uploadBox"
                  :show-file-list="false"
                  :action="datas"
                  :on-success="handlerSuccessUploadImgUrLSYXK"
                  :before-upload="beforeUploadImgUrLSYXK"
                  :on-error="handlerErrorUploadImgUrLSYXK"
                  :headers="uploadHeader()"
                >
                  <div class="uploadButton">上传许可证</div>
                </el-upload>
                <div class="imgRuleDscp">原件扫描上传，图片大小不超过2M，文件格式为jpg、jpeg、png</div>
                <div class="seeImgEx" @click="showExp('imgUrlLSXK')">查看样例</div>
              </dd>
            </dl>
            <dl class="uploadItem" v-if="ruleForm.enterpriseCategoryId == 4">
              <dt v-loading="imgUrlYYLd">
                <img v-if="!imgUrlYY" src="../../../assets/images/enterprise/yyzzsl_img.png" />
                <img v-if="imgUrlYY" :src="imgUrlYY" />
              </dt>
              <dd>
                <el-upload
                  class="uploadBox"
                  :show-file-list="false"
                  :action="datas"
                  :on-success="handlerSuccessUploadImgUrlYY"
                  :before-upload="beforeUploadImgUrlYY"
                  :on-error="handlerErrorUploadImgUrlYY"
                  :headers="uploadHeader()"
                >
                  <!-- <img v-if="imageUrly" :src="imageUrly" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
                  <div class="uploadButton">上传营业执照副本</div>
                </el-upload>
                <div class="imgRuleDscp">原件扫描上传，图片大小不超过2M，文件格式为jpg、jpeg、png</div>
                <div class="seeImgEx" @click="showExp('imgUrlYY')">查看样例</div>
              </dd>
            </dl>
            <!-- <dl class="uploadItem">
              <dt v-loading="imgUrlWTLd">
                <img v-if="!imgUrlWT" src="../../../assets/images/enterprise/wts_img.png">
                <img v-if="imgUrlWT" :src="imgUrlWT">
              </dt>
              <dd>
                <el-upload
                  class="uploadBox"
                  :show-file-list="false"
                  :action="datas"
                  :on-success="handlerSuccessUploadImgUrlWT"
                  :before-upload="beforeUploadImgUrlWT"
                  :on-error="handlerErrorUploadImgUrlWT"
                  :headers="uploadHeader()"
                >
                  <img v-if="imageUrly" :src="imageUrly" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  <div class="uploadButton">上传委托书</div>
                </el-upload>
                <div class="imgRuleDscp">原件扫描上传，图片大小不超过2M，文件格式为jpg、jpeg、png</div>
                <div class="seeImgEx" @click="downLoad('/授权委托书.docx')">《授权委托书》模板下载</div>
              </dd>
            </dl>-->

            <!-- <dl class="uploadItem">
              <dt v-loading="imgUrlSEALLd">
                <img v-if="!imgUrlSEAL" src="../../../assets/images/enterprise/qyyz_seal_img.png">
                <img v-if="imgUrlSEAL" style="width:130px;" :src="imgUrlSEAL">
              </dt>
              <dd>
                <el-upload
                  class="uploadBox"
                  :show-file-list="false"
                  :action="datas"
                  :on-success="handlerSuccessUploadImgUrlSEAL"
                  :before-upload="beforeUploadImgUrlSEAL"
                  :headers="uploadHeader()"
                  :on-error="handlerErrorUploadImgUrlSEAL"
                >
                  <img v-if="imageUrly" :src="imageUrly" class="avatar">
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  <div class="uploadButton">上传企业印章</div>
                </el-upload>
                <div class="imgRuleDscp">原件扫描上传，图片大小不超过2M，文件格式为jpg、jpeg、png</div>
                <div class="seeImgEx" @click="showExp('imgUrlSEAL')">查看样例</div>
              </dd>
            </dl>-->
          </div>
        </div>

        <div class="uploadFilesBox" v-show="uploadSecond">
          <div class="filesHead ft18">
            <ul>
              <li></li>
              <li>{{legalPersonType=='1'?'法人代表信息':'基本信息'}}</li>
            </ul>
          </div>
          <div class="fillInBox ft14">
            <el-form
              :model="ruleForm2"
              :rules="rules2"
              ref="ruleForm2"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item>
                <el-radio-group v-model="legalPersonType" @change="legalPersonTypeChange">
                  <el-radio label="1">我是法人代表</el-radio>
                  <el-radio label="2">我是受托人</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="证件类型：" prop="regionType">
                <el-select
                  v-model="ruleForm2.regionType"
                  placeholder="请选择证件类型"
                  @change="wacthRegionType"
                >
                  <el-option
                    v-for="item in documentType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="国籍：" prop="nationality" v-if="ruleForm2.regionType!=1">
                <el-select
                  v-model="ruleForm2.nationality"
                  placeholder="请选择国籍"
                  :disabled="isNationAble"
                  class="search_nation_p"
                  @visible-change="wacthNationValue"
                >
                  <div class="search_nation_box">
                    <p class="search_nation">
                      <img src="../../../assets/images/PersonalCertificate/searc_nation.png" />
                      <input
                        placeholder="搜索国家/地区名称"
                        v-model="searchNationValue"
                        @input="searchNationality"
                      />
                    </p>
                  </div>
                  <div style="height:40px;"></div>
                  <el-option
                    v-for="item in nationalityList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
                <!-- <el-select v-else v-model="ruleForm2.nationality" placeholder="请选择国籍" :disabled="isNationAble"  class="search_nation_p">
                    <el-option
                      v-for="item in nationalityListnew"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                </el-select>-->
              </el-form-item>
              <el-form-item label="姓名：" prop="legalPersonName">
                <el-input
                  type="text"
                  v-model="ruleForm2.legalPersonName"
                  autocomplete="off"
                  placeholder="请填写姓名"
                ></el-input>
              </el-form-item>
              <el-form-item label="职位：" prop="legalPersonPost">
                <el-input v-model="ruleForm2.legalPersonPost" placeholder="输入职位"></el-input>
              </el-form-item>
              <el-form-item label="性别：" prop="usersex" v-if="ruleForm2.regionType!=1">
                <el-select v-model="ruleForm2.usersex" placeholder="请选择性别">
                  <el-option
                    v-for="item in sexArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <template v-if="ruleForm2.regionType!=1">
                <el-form-item label="出生日期：" prop="birthDate">
                  <el-date-picker
                    type="date"
                    value-format="yyyy-MM-dd"
                    v-model="ruleForm2.birthDate"
                    placeholder="请选择您的出生日期"
                  ></el-date-picker>
                </el-form-item>
                <div style="display:flex;">
                  <el-form-item prop="dataEnd" label="证件有效期：">
                    <el-date-picker
                      type="date"
                      value-format="yyyy-MM-dd"
                      v-model="ruleForm2.dataEnd"
                      placeholder="结束日期"
                    ></el-date-picker>
                  </el-form-item>
                </div>
                <el-form-item label="证件号码：" prop="cardID">
                  <el-input
                    type="text"
                    v-model="ruleForm2.cardID"
                    autocomplete="off"
                    placeholder="输入证件号码"
                  ></el-input>
                </el-form-item>
              </template>

              <el-form-item label="身份证号码：" prop="legalPersonIdcardNumber" v-if="ruleForm2.regionType==1">
                <el-input
                  type="text"
                  v-model="ruleForm2.legalPersonIdcardNumber"
                  autocomplete="off"
                  placeholder="输入身份证号码"
                ></el-input>
              </el-form-item>
              <el-form-item label="手机号：" prop="legalPersonMoblie">
                <el-input v-model="ruleForm2.legalPersonMoblie" placeholder="输入手机号"></el-input>
              </el-form-item>
              <el-form-item label="短信验证码：" prop="code" class="codeBox">
                <el-input v-model="ruleForm2.code" placeholder="输入验证码"></el-input>
                <span
                  v-show="sendAuthCode"
                  class="code"
                  @click="getCode"
                  style="color:#E88078"
                >获取验证码</span>
                <span v-show="!sendAuthCode" class="code" style="color:#E88078">{{auth_time}}秒后重新获取</span>
              </el-form-item> 
              <el-form-item style="display:none;">
                <el-button type="primary" class="sunCard" @click="subCard('ruleForm2')">提交</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>

        <div class="uploadFilesBox" v-show="uploadSecond&& legalPersonType == '2'">
          <div class="filesHead ft18">
            <ul>
              <li></li>
              <li>法人代表信息</li>
            </ul>
          </div>
          <div class="fillInBox ft14">
            <el-form
              :model="ruleForm3"
              :rules="rules3"
              ref="ruleForm3"
              label-width="100px"
              class="demo-ruleForm"
            >
              <el-form-item label="证件类型：" prop="regionType">
                <el-select
                  v-model="ruleForm3.regionType"
                  placeholder="请选择证件类型"
                  @change="wacthRegionType"
                >
                  <el-option
                    v-for="item in documentType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="国籍：" prop="nationality" v-if="ruleForm3.regionType!=1">
                <el-select
                  v-model="ruleForm3.nationality"
                  placeholder="请选择国籍"
                  :disabled="isNationAble"
                  class="search_nation_p"
                  @visible-change="wacthNationValue"
                >
                  <div class="search_nation_box">
                    <p class="search_nation">
                      <img src="../../../assets/images/PersonalCertificate/searc_nation.png" />
                      <input
                        placeholder="搜索国家/地区名称"
                        v-model="searchNationValue"
                        @input="searchNationality"
                      />
                    </p>
                  </div>
                  <div style="height:40px;"></div>
                  <el-option
                    v-for="item in nationalityList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="姓名：" prop="legalPersonName">
                <el-input
                  type="text"
                  v-model="ruleForm3.legalPersonName"
                  autocomplete="off"
                  placeholder="请填写姓名"
                ></el-input>
              </el-form-item>
              <el-form-item label="职位：" prop="legalPersonPost">
                <el-input v-model="ruleForm3.legalPersonPost" placeholder="输入职位"></el-input>
              </el-form-item>
              <el-form-item label="性别：" prop="usersex" v-if="ruleForm3.regionType!=1">
                <el-select v-model="ruleForm3.usersex" placeholder="请选择性别">
                  <el-option
                    v-for="item in sexArr"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <template v-if="ruleForm3.regionType!=1">
                <el-form-item label="出生日期：" prop="birthDate">
                  <el-date-picker
                    type="date"
                    value-format="yyyy-MM-dd"
                    v-model="ruleForm3.birthDate"
                    placeholder="请选择您的出生日期"
                  ></el-date-picker>
                </el-form-item>
                <div style="display:flex;">
                  <el-form-item prop="dataEnd" label="证件有效期：">
                    <el-date-picker
                      type="date"
                      value-format="yyyy-MM-dd"
                      v-model="ruleForm3.dataEnd"
                      placeholder="结束日期"
                    ></el-date-picker>
                  </el-form-item>
                </div>
                <el-form-item label="证件号码：" prop="cardID">
                  <el-input
                    type="text"
                    v-model="ruleForm3.cardID"
                    autocomplete="off"
                    placeholder="输入证件号码"
                  ></el-input>
                </el-form-item>
              </template>

              <el-form-item label="身份证号码：" prop="legalPersonIdcardNumber" v-if="ruleForm3.regionType==1">
                <el-input
                  type="text"
                  v-model="ruleForm3.legalPersonIdcardNumber"
                  autocomplete="off"
                  placeholder="输入身份证号码"
                ></el-input>
              </el-form-item>
              <el-form-item label="手机号：" prop="legalPersonMoblie">
                <el-input v-model="ruleForm3.legalPersonMoblie" placeholder="输入手机号"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="uploadFilesBox" v-show="uploadSecond && legalPersonType == '2'">
          <div class="filesHead ft18">
            <ul>
              <li></li>
              <li>上传企业授权委托书</li>
              <!-- <li class="ft12">
                <span class="ft14">*</span>温馨提示：上传单张图片大小应小于5M，营业执照副本可支持JPEG、JPG、PNG格式
              </li>-->
            </ul>
          </div>
          <div class="filesContent">
            <dl class="uploadItem">
              <dt v-loading="imgUrlWTsLd">
                <img v-if="imgUrlWTs " :src="imgUrlWTs" />
                <img v-if="!imgUrlWTs" src="../../../assets/images/enterprise/wts_img.png" />
              </dt>
              <dd>
                <el-upload
                  class="uploadBox"
                  :show-file-list="false"
                  :action="datas"
                  :on-success="handlerSuccessUploadImgUrlWTs"
                  :before-upload="beforeUploadImgUrlWTs"
                  :on-error="handlerErrorUploadImgUrlWTs"
                  :headers="uploadHeader()"
                >
                  <!-- <img v-if="imgUrlWTs" :src="imgUrlWTs" class="avatar"> -->
                  <!-- <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
                  <div class="uploadButton">上传委托书</div>
                </el-upload>
                <div class="imgRuleDscp">原件扫描上传，图片大小不超过2M，文件格式为jpg、jpeg、png</div>
                <div class="seeImgEx" @click="downLoad('/授权委托书.docx')">《授权委托书》模板下载</div>
              </dd>
            </dl>
          </div>
        </div>
        <div class="uploadFilesBox completeBox textAlign" v-show="uploadthree">
          <div>
            <dl v-if="curinfos.legalPersonStatus == 1">
              <dt>
                <img src="../../../assets/images/enterprise/inreview_icon.png">
              </dt>
              <dd class="f20"><div class="userStatus">审核中</div>您的信息正在审核中，请耐心等待 <p style="font-size:12px;color:#E98880;padding-top:5px;">如果需要修改信息，请联系客服010-84716996</p></dd>
               
              <!-- <dd class="ft14">您的企业认证未通过，请核查后重新认证！</dd> -->
            </dl>
             <dl v-if="curinfos.legalPersonStatus == 2">
              <dt>
                <img src="../../../assets/images/enterprise/through_icon.png">
              </dt>
              <dd class="f20"><div class="userStatus">恭喜！您已通过补充资料认证！</div>企业名称：{{curinfos.enterpriseName}} </dd>
               
              <!-- <dd class="ft14">您的企业认证未通过，请核查后重新认证！</dd> -->
            </dl>
            <!-- <dl v-if="curinfos.legalPersonStatus == 3">
              <dt>
                <img src="../../../assets/images/enterprise/not pass_icon.png">
              </dt>
              <dd class="f20"><div class="userStatus">认证失败</div>您的补充资料审核未通过，请核查后重新认证 <div class="sunCard" @click="againsign">重新认证</div> </dd>
               
            </dl> -->
          </div>
        </div>
        <div class="enterpriseFoot textAlign ft16">
          <router-link to="home" tag="span" v-show="uploadFirst">取消</router-link>
          <button
            v-show="uploadFirst"
            :disabled="!isSubFlag"
            @click="realTrue"
            :style="{'background-color':isSubFlag?'#db4437':'#e3e3e3','border-color':isSubFlag?'#db4437':'#e3e3e3'}"
            class="cursorPointer"
          >确定</button>
          <!-- <button v-show="uploadSecond" @click="lastStepFn" class="cursorPointer">上一步</button> -->
          <button v-show="uploadSecond" @click="nextStep" style="margin:0 auto;" class="cursorPointer">下一步</button>
        </div>
      </div>
    </div>
    <div class="exampleBox" v-show="exType">
      <div class="conentExamp">
        <span></span>
        <img
          class="conentImg"
          v-if="exType == 'cardFace'"
          src="../../../assets/images/enterprise/front02_img.png"
        />
        <img
          class="conentImg"
          v-if="exType == 'cardBack'"
          src="../../../assets/images/enterprise/back02_img.png"
        />
        <img
          class="conentImg"
          v-if="exType == 'handCard'"
          src="../../../assets/images/enterprise/handCard.png"
        />
        <img
          class="conentImg"
          v-if="exType == 'imgUrlJG'"
          src="../../../assets/images/enterprise/zzjgdmz_yl_img.png"
        />
        <img
          class="conentImg"
          v-if="exType == 'imgUrlSYXK'"
          src="../../../assets/images/enterprise/sydwfrzs_yl_img.png"
        />
        <img
          class="conentImg"
          v-if="exType == 'imgUrlLSXK'"
          src="../../../assets/images/enterprise/lssws_yl_img.png"
        />
        <img
          class="conentImg"
          v-if="exType == 'imgUrlYY'"
          src="../../../assets/images/enterprise/license_img.png"
        />
        <!-- <img
          class="conentImg"
          v-if="exType == 'imgUrlWT'"
          src="../../../assets/images/enterprise/front02_img.png"
        >-->
        <!-- <img
          class="conentImg"
          v-if="exType == 'imgUrlSEAL'"
          src="../../../assets/images/enterprise/seal_yl_img.png"
        >-->
        <b class="colseDian" @click="exType=''">
          <img src="../../../assets/images/PersonalCertificate/delete_icon.png" />
        </b>
      </div>
    </div>
    <Dialog
      :visible="signing"
      :dialogTitle="'人脸识别认证'"
      v-on:closeDialog="closePassword"
      :width="'450px'"
    >
      <div slot="dialog" class="signing">
        <div class="rlsb">
           <p class="rlsb_title" v-show="!isStatusError"><span></span>&nbsp;二维码5分钟内有效&nbsp;<span></span> </p> 
             <div class="erweima" v-show="codeStatus!=0 && codeStatus!=1 && !error_num && !isStatusError">
                <vue-qr id="canvass" :text="erweimaUrl" :size="200"></vue-qr>
             </div>
              <div class="erweima_errro" v-show="error_erweima && codeStatus!=0 && codeStatus!=1 && !isStatusError">
                      <p class="error_title">二维码失效</p>
                        <span class="update_erweima" @click="updateEr">点击刷新</span>
                  </div>
                  <div class="erweima_errro" style="width: 270px;margin-left: -135px;" v-show="error_num">
                   <p class="error_title">{{text}}</p>
                </div>
                  <div class="erweima_success" v-show="(status==1||status==2) && codeStatus!=0 && codeStatus!=1 && !isStatusError">
                      <img style="width:30px;" src="../../../assets/images/userHome/wxsmcg_iconS.png"/>
                      <p class="success_title" style="margin-top: 0px">扫描成功</p>
                      <p class="success_desc" style="margin-bottom:5px;">请在手机端刷脸认证</p>
                      <span class="success_update_erweima"  @click="updateEr">点击刷新</span>
                  </div>
                  
                  <div class="erweima_success" v-show="codeStatus==0 || codeStatus==1">
                      <img style="width:30px;" src="../../../assets/images/userHome/wxsmcg_iconS.png"/>
                      <p class="success_title">已完成人脸验证</p>
                  </div>
                  <div class="erweima_success" v-show="isStatusError" style="top:41px;">
                    <img src="../../../assets/images/PersonalCertificate/error_icon.png" style="width:50px;"/>
                    <p class="success_title" style="padding-top:5px;">人脸识别认证失败</p>
                    <p class ="success_desc">请正确核对您的信息</p>
                    <span class="success_update_erweima" style="color: #a5303d;" @click="resetReaml">重新认证</span>
                </div>
             <p class="rlsb_desc" :style="{'margin-top':codeStatus==0 || codeStatus==1 || orderNo==-1?'220px':'20px'}" v-show="!isStatusError">
               请使用微信或其他软件扫描二维码，并依照提示完成人脸识别认证
             </p>
          <!-- <button class="success_face" type="button" v-show="status==1||status==2"  @click="getFaceResult">已完成人脸验证</button> -->
        </div>
      </div>
    </Dialog>
    <!-- 人脸识别失败 -->
    <Dialog
      :visible="CheckingInformation"
      :dialogTitle="'消息提示'"
      v-on:closeDialog="closeDialog"
      :width="'400px'"
    >
      <div slot="dialog" class="face_error_class">
        <div class="errorBox textAlign ft14">身份信息验证失败，请点击关闭重新进行认证！</div>
      </div>
    </Dialog>
    <!-- 人脸识别失败 -->
    <face-error v-if="codeStatus==-1&&openTest" :text="text"></face-error>
  </div>
</template>
<script>
import $ from "jquery";
import BaseApi from "@lib/baseApi.js";
import { AreaCascader } from "vue-area-linkage";
import breadcrumb from "@common/Breadcrumb.vue";
import country from "@lib/nationality.js";
import cryptoJs from "@lib/secret.js";
import { pca, pcaa } from "area-data";
import Reg from "@lib/reg.js";
import Util from "@lib/util.js";
import Dialog from "../../common/Dialog.vue";
import vueQr from "vue-qr"; //生成二维码插件
import faceError from "@common/faceError.vue"; //实名认证失败
import { mapMutations, mapGetters } from "vuex";
let judgeErrByParms = (data, callback, value, flag, flag1) => {
  if (data.enterpriseCategoryId == flag || data.enterpriseCategoryId == flag1) {
    if (value) {
      callback();
    } else {
      callback("请输入编号");
    }
  } else {
    callback();
  }
};
let imageMap = {
  imgUrlJG: "",
  imgUrlSYXK: "",
  imgUrlLSXK: "",
  imgUrlYY: "",
  imgUrlWT: ""
  // imgUrlSEAL: "",
  // imageUrlh: "",
  // imageUrlz: "",
  // imageUrlf: ""
};
export default {
  data() {
    var validateCard = (rule, value, callback) => {
      var common=/^[a-z|A-Z|0-9]{4,20}$/;
          if(!common.test(value)){
              callback(new Error("您输入的格式不对"));
            }
          callback();
      };
      var validateCards = (rule, value, callback) => {
      var isIDCard = /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
          if(!isIDCard.test(value)){
            callback(new Error("您输入的格式不对"));
          }
          callback();
      };
    var validateName = (rule, value, callback) => {
      var isName = /^[a-zA-Z\s*]{2,20}$/,//英文名
          rareWords=/^((?![\u3000-\u303F])[\u2E80-\uFE4F]|\·)*(?![\u3000-\u303F])[\u2E80-\uFE4F](\·)*$/;//普通汉字、生僻字
      if (!isName.test(value) && !rareWords.test(value)) {
        callback(new Error("您输入的格式不对"));
      }
      callback();
    };
    var validatePermit = (rule, value, callback) => {
      judgeErrByParms(this.ruleForm, callback, value, 2, 5);
    };
    var validateLicenseCode = (rule, value, callback) => {
      judgeErrByParms(this.ruleForm, callback, value, 4);
    };
    var validateZZJG = (rule, value, callback) => {
      if (!this.checked) {
        if (value) {
          callback();
        } else {
          callback("请输组织机构代码");
        }
      } else {
        callback();
      }
    };
   var valbirthDate=(rule, value, callback) => {
        let currentTime = new Date();
        let newDate=new Date(
         currentTime.getFullYear()+'',
         currentTime.getMonth()+1+'',
         currentTime.getDate()+''
        ).getTime();
        let startTime = new Date(
          this.ruleForm2.birthDate.slice(0, 4),
          this.ruleForm2.birthDate.slice(5, 7),
          this.ruleForm2.birthDate.slice(8, 10)
        ).getTime();
        if(startTime>newDate){
           callback(new Error("选择的日期有误"));
        }
        callback();
    }
    var valdataEnd=(rule, value, callback) => {
        let currentTime = new Date();
        let newDate=new Date(
         currentTime.getFullYear()+'',
         currentTime.getMonth()+1+'',
         currentTime.getDate()+''
        ).getTime();
        let startTime = new Date(
          this.ruleForm2.dataEnd.slice(0, 4),
          this.ruleForm2.dataEnd.slice(5, 7),
          this.ruleForm2.dataEnd.slice(8, 10)
        ).getTime();
        if(startTime<newDate){
           callback(new Error("选择的日期有误"));
        }
        callback();
    }
    //验证手机号
    var validateMoblie =  (rule, value, callback) => {
      var isMoblie = /^((13[0-9])|(15[0-9])|(14[^4,\\D])|(16[0-9])|(17[0-9])|(18[0-9])||(19[8,9]))\d{8}$/;
      if (!isMoblie.test(value)) {
        callback(new Error("您输入的不是手机号"));
      }else{
        callback();
      }
    }
    return {
      CheckingInformation: false, //身份证认证失败
      erweimaUrl: "",
      //二维码扫描成功
      success_erweima: false,
      //二维码失效
      error_erweima: false,
      //二维码弹框
      signing: false,
      orderNo: "", //订单号
      status: 0, //二维码状态
      codeStatus: null, //认证状态
      // 是否展示三证合一选择框
      showCheck: false,
      //选择框的值
      checked: false,
      //当前显示的url
      currentUrl: "",
      ruleForm: {
        enterpriseName: "",
        enterpriseIndustryId: "",
        enterpriseCategoryId: "",
        licenseCode: "",
        address: [],
        enterpriseAddress: "",
        enterprisePhone: "",
        enterpriseFax: "",
        licenseCode: "",
        permit: "",
        ZZJG: "",
        postCode: ""
      },
      exType: "",
      imgUrlJG: false,
      imgUrlJGLd: false,
      imgUrlSYXK: "",
      imgUrlSYXKLd: false,
      imgUrlLSXK: "",
      imgUrlLSXKLd: false,
      imgUrlYY: "",
      imgUrlYYLd: false,
      imgUrlWT: "",
      imgUrlWTLd: false,
      imgUrlSEAL: "",
      imgUrlSEALLd: false,
      imageUrlz: "",
      imageUrlzLd: false,
      imageUrlf: "",
      imageUrlfLd: false,
      // 身份证手持
      imageUrlh: "",
      imageUrlhLd: false,
      rules: {
        enterpriseName: [
          { required: true, message: "请输入机构名称", trigger: "blur" },
          {
            min: 6,
            message: "最少输入6位任意字符",
            trigger: "blur"
          }
        ],
        enterpriseIndustryId: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        enterpriseCategoryId: [
          { required: true, message: "请选择", trigger: "change" }
        ],
        permit: [
          {
            max: 18,
            message: "最多18位",
            trigger: "blur"
          },
          {
            pattern: Reg.organizationCode,
            message: "格式不正确",
            trigger: "blur"
          },
          { validator: validatePermit, trigger: "blur" }
        ],
        licenseCode: [
          { validator: validateLicenseCode, trigger: "blur" },
          {
            max: 18,
            message: "最多18位",
            trigger: "blur"
          },
          {
            pattern: Reg.businessLicense,
            message: "格式不正确",
            trigger: "blur"
          },
          { required: true, message: "请输入营业执照注册号", trigger: "blur" }
        ],
        ZZJG: [
          {
            pattern: Reg.organizationCode,
            message: "格式不正确",
            trigger: "blur"
          },
          {
            max: 18,
            message: "最多18位",
            trigger: "blur"
          },
          { required: true, message: "请输入组织机构代码", trigger: "blur" }
          // { validator: validateZZJG, trigger: "blur" }
        ],
        enterprisePhone: [
          {
            pattern: Reg.fixedTele,
            message: "固定电话格式不正确",
            trigger: "blur"
          }
        ],
        enterpriseFax: [
          {
            pattern: Reg.faxTele,
            message: "传真格式不正确",
            trigger: "blur"
          }
        ],
        postCode: [
          {
            pattern: Reg.postCode,
            message: "邮政编码格式不正确",
            trigger: "blur"
          }
        ],
        address: [{ required: true, message: "请选择", trigger: "change" }],
        enterpriseAddress: [
          { required: true, message: "请输入详细的地址", trigger: "blur" }
        ]
      },
      ruleForm2: {
        legalPersonName: "",
        legalPersonMoblie: "",
        legalPersonIdcardNumber: "",
        code: "",
        regionType:"1",//证件类型
         usersex:"",
        birthDate:"",
        // dataStart:"",
        dataEnd:"",
        nationality:"",//国籍
        cardID:"",//证件号
        legalPersonPost: ""
      },
      legalPersonType: "1",

      ruleForm3: {
        legalPersonName: "",
        legalPersonMoblie: "",
        legalPersonIdcardNumber: "",
        legalPersonPosition: "",
        regionType:"1",//证件类型
         usersex:"",
        birthDate:"",
        // dataStart:"",
        dataEnd:"",
        nationality:"",//国籍
        cardID:"",//证件号
        legalPersonPost:''
      },
      imgUrlWTs: "", //企业委托书
      imgUrlWTsFilePath: "",
      imgUrlWTsLd: false,
      detailAuth: {},
      rules2: {
        legalPersonName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { validator: validateName, trigger: "blur" }
        ],
        legalPersonMoblie: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          { validator: validateMoblie, trigger: "blur" },
        ],
        legalPersonIdcardNumber: [
          { required: true, message: "请输入18位身份号", trigger: "blur" },
          {
            pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
            message: "您输入的格式不对",
            trigger: "blur"
          }
        ],
        code: [{ required: true, message: "请输入验证码", trigger: "blur" }],
        legalPersonPost: [
          { required: true, message: "请输入职位", trigger: "blur" }
        ],
        regionType: [
          { required: true, message: "请选择证件类型", trigger: "blur" },
        ],
         usersex: [
          { required: true, message: "请选择性别", trigger: "change" },
        ],
         birthDate: [
          { required: true, message: "请选择出生日期", trigger: "blur" },
           { validator: valbirthDate, trigger: "blur" }
        ],
        //  dataStart: [
        //   { required: true, message: "请选择证件开始日期", trigger: "blur" },
        // ],
        dataEnd: [
          { required: true, message: "请选择证件失效日期", trigger: "blur" },
           { validator: valdataEnd, trigger: "blur" }
        ],
        nationality: [
          { required: true, message: "请选择国籍", trigger: "blur" },
        ],
         cardID: [
          { required: true, message: "请输入证件号码", trigger: "blur" },
          { validator: validateCard, trigger: "blur" }
        ],
      },
      rules3: {
        legalPersonName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
          { validator: validateName, trigger: "blur" }
        ],
        legalPersonMoblie: [
          { required: true, message: "请输入手机号", trigger: "blur" },
           { validator: validateMoblie, trigger: "blur" },
          // {
          //   pattern: /^((13[0-9])|(15[0-9])|(14[^4,\\D])|(16[0-9])|(17[0-9])|(18[0-9])||(19[8,9]))\d{8}$/,
          //   message: "您输入的不是手机号",
          //   trigger: "blur"
          // }
        ],
        legalPersonPost: [
          { required: true, message: "请输入职位", trigger: "blur" }
        ],
        legalPersonIdcardNumber: [
          { required: true, message: "请输入18位身份号", trigger: "blur" },
          {
            pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/,
            message: "您输入的格式不对",
            trigger: "blur"
          }
        ],
        legalPersonPosition: [
          { required: true, message: "请输入职位", trigger: "blur" }
        ],
        regionType: [
          { required: true, message: "请选择证件类型", trigger: "blur" },
        ],
         usersex: [
          { required: true, message: "请选择性别", trigger: "change" },
        ],
         birthDate: [
          { required: true, message: "请选择出生日期", trigger: "blur" },
           { validator: valbirthDate, trigger: "blur" }
        ],
        //  dataStart: [
        //   { required: true, message: "请选择证件开始日期", trigger: "blur" },
        // ],
        dataEnd: [
          { required: true, message: "请选择证件失效日期", trigger: "blur" },
           { validator: valdataEnd, trigger: "blur" }
        ],
        nationality: [
          { required: true, message: "请选择国籍", trigger: "blur" },
        ],
         cardID: [
          { required: true, message: "请输入证件号码", trigger: "blur" },
          { validator: validateCard, trigger: "blur" }
        ],
       
      },
       isExist:false,
       documentType:[
        {
          value:"1",
          label:"中国大陆二代身份证"
        },
        {
          value:"2",
          label:"定居国外的中国公民护照"
        },
        {
          value:"3",
          label:"港澳居民来往内地通行证"
        },{
          value:"4",
          label:"台湾居民来往大陆通行证"
        },{
          value:"5",
          label:"中华人民共和国外国人永久居留证"
        }
      ],
       sexArr:[{
        value:"1",
        label:"男"
      },{
        value:"2",
        label:"女"
      }],
      auth_time: 0,
      sendAuthCode: true,
      selected: [],
      pcaa: pcaa,
      datas: "/common/upload",
      imageUrly: "",
      imageUrlq: "",
      exampleImg: true,
      cityshow: true,
      realName: true,
      uploadFirst: false,
      uploadSecond: false,
      uploadthree: false,
      type: "A",
      options: [],
      value4: "",
      units: [],
      unit: "",
      userID: "",
      error_num: false,
      text: "",
      openTest: false,
      enterpriseid: "",
      isSubFlag: true,
      curinfos: {},
      hDetail: {},
      enterpriseParams: {},
      isNationAble:false,
      nationalityList:[],
      nationalityListnew:[],
      searchNationValue:"",
      isStatusError:false,
      isUserDisabled:true,
      // legalPersonParams:{},//法人参数
      // curMobile:"18680546428", //特殊处理手机号
      // isNoCheck:false
    };
  },
  created() {
    this.getDic();
    this.getuserId();
    // this.userStatus();
    // this.getEnterprise();
    this.legalPersonType = this.$route.query.supplementFlagValue
      ? this.$route.query.supplementFlagValue
      : "1";
  },
  components: {
    breadcrumb,
    Dialog,
    faceError,
    vueQr
  },
  computed: {
    ...mapGetters(["getUserInfo", "getCurInfo"])
  },
  mounted() {

  },
  methods: {
    ...mapMutations(["setUserInfo", "setCurrentInfo"]),
   getuserId(){
      this.$store.commit('showLoading', true);
      BaseApi.createRpcToken("/user/v2/getUserInfo","GET").then(data=>{
        this.$store.commit('showLoading', false);
        if(data.code==200){
          sessionStorage.setItem("userInfo",JSON.stringify(data.datas));
          this.setUserInfo(data.datas);
          if(data.datas.enterpriseList.length){
            this.enterpriseid=data.datas.enterpriseList[0].id
            this.userID=data.datas.enterpriseList[0].userId;
          }else{
            this.userID=this.$route.query.exId?this.$route.query.exId:"";
          }    
          this.userID=data.datas.currentUserId;
          
          if(data.datas.enterpriseList.length){
            let userArr=data.datas.enterpriseList
            let curInfo=userArr.filter(item=>item.userId==data.datas.currentUserId)
            this.curinfos=curInfo[0]
          if(userArr[0].authenticationStatus==1){
            this.userStatus();
          }else if(userArr[0].authenticationStatus==2 && !this.$route.query.flag){
            // this.$router.replace("/personal/users/home")
          }else if(this.curinfos.authenticationStatus==2 && this.$route.query.flag){
            //补充资料信息
            if(this.curinfos.authenticationStatus==2 && (this.curinfos.legalPersonStatus == 1 || this.curinfos.legalPersonStatus == 2)){
              $(".threeSteps li")
                    .eq()
                    .find("span")
                    .addClass("stepWalk");
                  $(".enterpriseStep")
                    .eq(1)
                    .addClass("stepWalk");
                  $(".enterpriseStep")
                    .eq(1)
                    .siblings("p")
                    .addClass("stepWalk");
                    $(".enterpriseStep")
                    .eq(0)
                    .siblings("p")
                    .addClass("stepWalk");
                  this.uploadSecond=false;
                  this.uploadthree=true;
                  
            }else{

            // $(".threeSteps li")
            //         .eq()
            //         .find("span")
            //         .addClass("stepWalk");
                  // $(".enterpriseStep")
                  //   .eq(1)
                  //   .addClass("stepWalk");
                  $(".enterpriseStep")
                    .eq(0)
                    .siblings("p")
                    .addClass("stepWalk");
                    $(".enterpriseStep")
                    .eq(1)
                    .siblings("p")
                    .removeClass("stepWalk");
                  this.checked=false;
                  // this.getEnterprise();
                  // $(".enterpriseBox").animate({ scrollTop: 0 }, 1);
                  this.uploadSecond = true;
            }

          }
            this.setCurrentInfo(curInfo[0])
          }
        
        }
      },data=>{})
      .catch(function(e) {
        errorLog(e);
      });
    },
    searchNationality(){
      if(this.searchNationValue==""){
         this.nationalityList=country.country.filter(item=>item.label!="中国");
      }else{
         this.nationalityList=country.country.filter(item=>item.label.indexOf(this.searchNationValue)!=-1 && item.label !="中国");
      }
    },
    wacthNationValue(data){
      if(!data){//false是弹框隐藏
        this.searchNationValue="";
        this.nationalityList=country.country.filter(item=>item.label!="中国");
      }
    },
    wacthRegionType(flag){
      this.nationalityList=country.country;
      if(this.ruleForm2.regionType==2){
        this.ruleForm2.nationality="CHN";
        this.isNationAble=true;
      }else if(this.ruleForm2.regionType==4){
         this.ruleForm2.nationality="CHN";
        this.isNationAble=true;
      }else if(this.ruleForm2.regionType==3){
        this.ruleForm2.nationality="CHN";
        this.isNationAble=true;
      }else{
        this.isNationAble=false;
        if(!flag){
          this.ruleForm2.nationality="";
        }
        this.nationalityList=country.country.filter(item=>item.label!="中国");
      }
      this.$refs.ruleForm2.clearValidate();
    },
    //选择受托人-法人
    legalPersonTypeChange(){
      this.ruleForm2.code='';
      if(this.curinfos.authenticationStatus == 2 &&  (this.curinfos.legalPersonStatus == 0 || this.curinfos.legalPersonStatus == 3 || this.curinfos.legalPersonStatus == 5) ){
        this.setDataInfo(this.hDetail)
      }
    },
    userStatus(){
         $(".threeSteps li")
        .eq(2)
        .find("span")
        .addClass("stepWalk");
      $(".enterpriseStep")
        .eq(1)
        .addClass("stepWalk");
      $(".enterpriseStep")
        .eq(0)
        .siblings("p")
        .addClass("stepWalk");
      $(".threeSteps li")
        .eq(4)
        .find("span")
        .addClass("stepWalk");
      $(".threeSteps li")
        .eq(6)
        .find("span")
        .addClass("stepWalk");
      $(".enterpriseStep")
        .eq(2)
        .addClass("stepWalk");
      // $(".enterpriseStep")
      //   .eq(2)
      //   .siblings("p")
      //   .addClass("stepWalk");
      this.uploadSecond = true;
      this.uploadFirst =false;
      this.uploadthree = false;
    },
    //重新认证
    resetReaml(){
      this.signing=false;
      this.isStatusError=false;
      this.ruleForm2.code="";
    },
    //获取实名人脸二维码
  getFaceAuthOrderNo() {
      var timer = null;
      let userIDd = this.$route.query.exId
        ? this.$route.query.exId
        : this.userID;
      //第三步进行人脸识别验证
      let queryStrUrl = {
        liveType: 5,
        contractId: "",
        userId: userIDd
      };
      if (this.$route.query.flag == 2) {
        //补充信息
        queryStrUrl.liveType = 5;
      }
      //获取二维码地址
      clearInterval(timer);
      BaseApi.createRpcToken("/user/getFaceAuthOrderNo", queryStrUrl, "GET")
        .then(
          data => {
          this.$store.commit("showLoading", false);
            if (data.code == 200) {
               var endTime = new Date().getTime()+5*60*1000;
          this.orderNo=data.datas.orderNo;//data.datas.url
          if(data.datas.orderNo!=-1){
            this.setTimerEr();
              // await this.getuserId();
              let userIDd=localStorage.getItem('userId')?localStorage.getItem('userId'):this.userID,
                  tokenId=localStorage.getItem('token'),
                  idNumbers='',
                  curTime=new Date().format("YYYY/MM/DD"),
                  curUrl=`orderNo=${data.datas.orderNo}&typesP=5&token=${tokenId}&operatorType=${this.legalPersonType}&id=${this.enterpriseid}`;
              // 选择法人代表
              if(this.legalPersonType == '1'){ 
                if(this.ruleForm2.regionType==1){//身份证类型
                  curUrl+=`&legalPersonName=${cryptoJs.Encrypt(curTime+this.ruleForm2.legalPersonName)}&legalPersonIdcardNumber=${cryptoJs.Encrypt(curTime+this.ruleForm2.legalPersonIdcardNumber.toLocaleUpperCase())}&idType=${this.ruleForm2.regionType}&code=${this.ruleForm2.code}&legalPersonMoblie=${this.ruleForm2.legalPersonMoblie}&legalPersonPost=${this.ruleForm2.legalPersonPost}`
                }else{
                  curUrl+=`&legalPersonName=${cryptoJs.Encrypt(curTime+this.ruleForm2.legalPersonName)}&legalPersonIdcardNumber=${cryptoJs.Encrypt(curTime+this.ruleForm2.cardID.toLocaleUpperCase())}&idType=${this.ruleForm2.regionType}&nation=${this.ruleForm2.nationality}&sex=${this.ruleForm2.usersex}&birthDate=${this.ruleForm2.birthDate}&expiryDate=${this.ruleForm2.dataEnd}&code=${this.ruleForm2.code}&legalPersonMoblie=${this.ruleForm2.legalPersonMoblie}&legalPersonPost=${this.ruleForm2.legalPersonPost}`
                }             
              }else{ //选择受委托人
                //受托人
                if(this.ruleForm2.regionType==1){//身份证类型
                  curUrl+=`&powerOfAttorneyWatermarkedPath=${this.imgUrlWTsFilePath}&adminPersonName=${cryptoJs.Encrypt(curTime+this.ruleForm2.legalPersonName)}&adminPersonIdcardNumber=${cryptoJs.Encrypt(curTime+this.ruleForm2.legalPersonIdcardNumber.toLocaleUpperCase())}&adminPersonIdtype=${this.ruleForm2.regionType}&code=${this.ruleForm2.code}&adminPersonMoblie=${this.ruleForm2.legalPersonMoblie}&adminPersonPost=${this.ruleForm2.legalPersonPost}`
                }else{
                  curUrl+=`&powerOfAttorneyWatermarkedPath=${this.imgUrlWTsFilePath}&adminPersonName=${cryptoJs.Encrypt(curTime+this.ruleForm2.legalPersonName)}&adminPersonIdcardNumber=${cryptoJs.Encrypt(curTime+this.ruleForm2.cardID.toLocaleUpperCase())}&adminPersonIdtype=${this.ruleForm2.regionType}&adminPersonNation=${this.ruleForm2.nationality}&adminPersonSex=${this.ruleForm2.usersex}&adminPersonBirthDate=${this.ruleForm2.birthDate}&adminPersonExpiryDate=${this.ruleForm2.dataEnd}&code=${this.ruleForm2.code}&adminPersonMoblie=${this.ruleForm2.legalPersonMoblie}&adminPersonPost=${this.ruleForm2.legalPersonPost}`
                }
                //法人
                if(this.ruleForm3.regionType==1){
                  curUrl+=`&legalPersonName=${cryptoJs.Encrypt(curTime+this.ruleForm3.legalPersonName)}&legalPersonIdcardNumber=${cryptoJs.Encrypt(curTime+this.ruleForm3.legalPersonIdcardNumber.toLocaleUpperCase())}&idType=${this.ruleForm3.regionType}&legalPersonMoblie=${this.ruleForm3.legalPersonMoblie}&legalPersonPost=${this.ruleForm3.legalPersonPost}`  
                }else{
                  curUrl+=`&legalPersonName=${cryptoJs.Encrypt(curTime+this.ruleForm3.legalPersonName)}&legalPersonIdcardNumber=${cryptoJs.Encrypt(curTime+this.ruleForm3.cardID.toLocaleUpperCase())}&idType=${this.ruleForm3.regionType}&nation=${this.ruleForm3.nationality}&sex=${this.ruleForm3.usersex}&birthDate=${this.ruleForm3.birthDate}&expiryDate=${this.ruleForm3.dataEnd}&legalPersonMoblie=${this.ruleForm3.legalPersonMoblie}&legalPersonPost=${this.ruleForm3.legalPersonPost}`
                }
              }
              console.log(curUrl)
              // ${window.location.origin}-https://gzfq_fq_test.ip360.org
              this.erweimaUrl=`${window.location.origin}/m/sign-perStartFace?${curUrl}`;
              timer=setInterval(()=>{
                var start =  new Date().getTime();
                if(start > endTime){
                  // //console.log("end time er")
                  this.error_erweima=true;
                  this.status=0;
                  clearInterval(timer)
                }else{
                  if(this.status==1||this.status==2){
                    clearInterval(timer) 
                    this.error_erweima=false;
                  }else{
                    this.error_erweima=false;
                  }
                }
              },1000)
              if(this.status==1||this.status==2){
                clearInterval(timer) 
                this.error_erweima=false;
              }
            } else {
              this.text = " 人脸识别服务异常，请联系管理员！";
              this.error_num = true;
              this.status = 0;
              this.error_erweima = false;
            }
          } else {
            // console.log('erweimadizhi error',data)
            this.error_erweima = true;
            this.status = 0;
          }
        },
        data => {
          if (data.code == 107) {
            this.error_erweima = true;
          }
        }
      )
      .catch(function(e) {
        errorLog(e);
      });
    },
    setTimerEr() {
      var timer = null;
      let orderNos = this.orderNo;
      var obj = { orderNo: orderNos };
      BaseApi.createRpcToken(
        "/user/getFaceAuthStatus",
        { orderNo: orderNos },
        "GET"
      )
        .then(
          data => {
            if (data.code == 200) {
              clearTimeout(timer);
              this.status = data.datas.status;
              this.codeStatus = data.datas.authStauts;
              timer = setTimeout(() => {
                this.setTimerEr();
              }, 1000);
              if (obj.orderNo != this.orderNo) {
                clearTimeout(timer);
              }
              //二维码失效
              else if (this.error_erweima) {
                clearTimeout(timer);
              }
              //成功
              else if (data.datas.authStauts == 0) {
                clearTimeout(timer);
              }
              //失败0-成功，-1未完成，其余都是失败。
              else if (
                data.datas.authStauts != 0 &&
                data.datas.authStauts != -1
              ) {
                clearTimeout(timer);
              }
              if(this.status==2){
                this.getFaceResult();
                clearTimeout(timer)
              }
            } else {
              clearTimeout(timer); //清理定时任务
            }
          },
          data => {}
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    //刷新二维码
    updateEr() {
      if (this.codeStatus == 0) {
        return;
      } else {
        this.error_erweima = false;
        this.getFaceAuthOrderNo();
      }
    },
    //获取实名认证结果
    getFaceResult(){
       var timer=null;
      let orderNos=this.orderNo;
      clearTimeout(timer);
         if(this.codeStatus==0){
          BaseApi.createRpcToken("/user/getFaceAuthStatus",{orderNo:orderNos},"GET").then(data=>{
            if(data.datas.authStauts==0){
              this.signing=false;
              //提交验证结果
              // that.subCardface()
                          $(".threeSteps li").find("span")
                    .addClass("stepWalk");
                  $(".enterpriseStep")
                    .eq(1)
                    .addClass("stepWalk");
                  $(".enterpriseStep")
                    .eq(1)
                    .siblings("p")
                    .addClass("stepWalk");
                this.uploadSecond = false;
                this.uploadthree = true;
                this.getuserId();
               
                
            }else{
              that.codeStatus=data.datas.authStauts;
            }
          }, data => {})
          .catch(function (e) {
            errorLog(e);
          });
        } else{
          this.codeStatus=-1;
          this.openTest=true;
          this.text="人脸识别认证失败，请重试";
          timer=setTimeout(()=>{
              this.codeStatus=-2;
              this.openTest=false;
          },5000)
        }
    },

    handlerPress(flag) {
    },
    getEnterprise() {
      let exId = this.curinfos.id
        ? this.curinfos.id
        : localStorage.getItem("enterpriseId");
      BaseApi.createRpcToken("/user/v2/getUserAuthInfo", {
        enterpriseId: this.curinfos.id,
        type: 2
      })
        .then(
          data => {
            let detail = data.datas;
            this.hDetail = detail;
            if (detail) {
              (this.ruleForm.enterpriseName = detail.enterpriseName),
                (this.ruleForm.enterpriseIndustryId =
                  detail.enterpriseIndustryId);
              this.ruleForm.enterpriseCategoryId = detail.enterpriseCategoryId;
              this.ruleForm.licenseCode = detail.licenseCode;
              this.ruleForm.ZZJG = detail.organizationCode;
              this.ruleForm.permit = detail.permit;
              this.ruleForm.enterpriseAddress = detail.enterpriseAddress;
              let address = [
                detail.provinceName,
                detail.cityName,
                detail.areaName
              ];
              this.ruleForm.address = address;
              this.ruleForm.postCode = detail.postCode;
              this.ruleForm.enterprisePhone = detail.enterprisePhone;
              this.ruleForm.enterpriseFax = detail.enterpriseFax;
              imageMap["imgUrlJG"] = detail.organizationCodeWatermarkedPath;
              this.imgUrlJG = detail.organizationCodeWatermarkedUrl;
              // imageMap["imgUrlWT"] = detail.powerOfAttorneyWatermarkedPath;
              // this.imgUrlWT = detail.powerOfAttorneyWatermarkedUrl;
              // imageMap["imgUrlSEAL"] = detail.enterpriseSealWatermarkedPath;
              // this.imgUrlSEAL = detail.enterpriseSealWatermarkedUrl;
              imageMap["imgUrlYY"] = detail.licenseWatermarkedPath;
              this.imgUrlYY = detail.licenseWatermarkedUrl;
              imageMap["imgUrlYY"] = detail.licenseWatermarkedPath;
              this.imgUrlYY = detail.licenseWatermarkedUrl;
              this.checked = detail.licenceUnited == "1" ? true : false;
              if (this.ruleForm.enterpriseCategoryId == 5) {
                imageMap["imgUrlLSXK"] = detail.permitWatermarkedPath;
                this.imgUrlLSXK = detail.permitWatermarkedUrl;
              } else {
                imageMap["imgUrlSYXK"] = detail.permitWatermarkedPath;
                this.imgUrlSYXK = detail.permitWatermarkedUrl;
              }
              if(detail.nation){
                  this.wacthRegionType(true);
              }else{
                  this.wacthRegionType();
              }
              // this.legalPersonType=detail.operatorType+'';
              this.setDataInfo(detail);
              // $(".threeSteps li")
              //   .eq(2)
              //   .find("span")
              //   .addClass("stepWalks");
              // $(".enterpriseStep")
              //   .eq(1)
              //   .addClass("stepWalks");
              // $(".enterpriseStep")
              //   .eq(1)
              //   .siblings("p")
              //   .addClass("stepWalks");
              // this.uploadSecond = true;
              // this.uploadFirst = false;
              if(this.curinfos.authenticationStatus == 2 &&  (this.curinfos.legalPersonStatus == 1 || this.curinfos.legalPersonStatus == 2 ) ){
                 $(".threeSteps li")
                    .find("span")
                    .addClass("stepWalk");
                  $(".enterpriseStep")
                    .eq(1)
                    .addClass("stepWalk");
                  $(".enterpriseStep")
                    .eq(1)
                    .siblings("p")
                    .addClass("stepWalk");
                  this.uploadSecond = false;
                  this.uploadthree = true;
                 }else{
                    $(".enterpriseStep")
                   .eq(0)
                   .siblings("p")
                   .addClass("stepWalk");
                    this.checked=false;
                    // this.getEnterpriseUser();
                    // $(".enterpriseBox").animate({ scrollTop: 0 }, 1);
                    this.uploadSecond = true;
                 }
            }
          },
          data => {}
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    //设置回显经办人信息
    setDataInfo(detail) {
       this.isDisabled=false;
      if (detail.operatorType == "1") {
        //法人代表
        this.ruleForm2.legalPersonName = detail.legalPersonName;
        this.ruleForm2.legalPersonIdcardNumber = detail.legalPersonIdcardNumber;
        this.ruleForm2.legalPersonMoblie = detail.legalPersonMoblie;
        this.ruleForm2.legalPersonPost = detail.legalPersonPost;
        this.ruleForm2.regionType=detail.idType && detail.idType!='undefined'?detail.idType+'':'1';
        this.ruleForm2.usersex=detail.sex?detail.sex+'':'1';
        this.ruleForm2.birthDate=detail.birthDate;
        this.ruleForm2.dataEnd=detail.expiryDate;
        this.ruleForm2.nationality=detail.nation;
      } else {
        //受托人
        this.ruleForm2.legalPersonName = detail.adminPersonName;
        this.ruleForm2.legalPersonIdcardNumber = detail.adminPersonIdcardNumber;//证件号
        this.ruleForm2.cardID=detail.adminPersonIdcardNumber;
        this.ruleForm2.legalPersonMoblie = detail.adminPersonMoblie;
        this.ruleForm2.legalPersonPost = detail.adminPersonPost;
        this.ruleForm2.regionType=detail.adminPersonIdType && detail.adminPersonIdType!='undefined'?detail.adminPersonIdType+'':'1';//证件类型
        this.ruleForm2.usersex=detail.adminPersonSex+'';//性别
        this.ruleForm2.birthDate=detail.adminPersonBirthDate;//出生日期
        this.ruleForm2.dataEnd=detail.adminPersonExpiryDate;//证件有效期
        this.ruleForm2.nationality=detail.adminPersonNation;//国籍
         //法人
        this.ruleForm3.legalPersonName = detail.legalPersonName;
        this.ruleForm3.legalPersonIdcardNumber = detail.legalPersonIdcardNumber;
        this.ruleForm3.legalPersonMoblie = detail.legalPersonMoblie;
        this.ruleForm3.legalPersonPosition = detail.legalPersonPost;
        this.imgUrlWTs = detail.powerOfAttorneyWatermarkedUrl;
        this.imgUrlWTsFilePath = detail.powerOfAttorneyWatermarkedPath;
        this.ruleForm3.regionType=detail.idType && detail.idType!='undefined'?detail.idType+'':'1';
        this.ruleForm3.usersex=detail.sex?detail.sex+'':'1';
        this.ruleForm3.birthDate=detail.birthDate;
        this.ruleForm3.dataEnd=detail.expiryDate;
        this.ruleForm3.nationality=detail.nation;
      }
    },
    getEnterpriseUser() {
      let params = {
        enterpriseId: this.curinfos.id ? this.curinfos.id : this.enterpriseid,
        type: 2
      };
      this.$store.commit("showLoading", true);
      BaseApi.createRpcToken("/user/v2/getUserAuthInfo", params)
        .then(data => {
          this.$store.commit("showLoading", false);
          this.detailAuth = data.datas;
          if (data.datas) {
            // this.legalPersonType=this.detailAuth.operatorType+'';
            this.setDataInfo(this.detailAuth);
            //  this.imageUrlz = this.detailAuth.idcardFrontWatermakedUrl? this.detailAuth.idcardFrontWatermakedUrl :this.detailAuth.idcardFrontWatermarkedUrl;
            // this.imageUrlf = this.detailAuth.idcardReverseWatermakedUrl?this.detailAuth.idcardReverseWatermakedUrl:this.detailAuth.idcardFrontWatermarkedPath;
            // this.imageUrlh = this.detailAuth.handCardWatermakedUrl;
          }
        })
        .catch(function(e) {
          errorLog(e);
        });
    },
    showExp(value) {
      this.exType = value;
    },
    setCurrentUrl(url) {
      this.currentUrl = url;
    },
    uploadHeader() {
      return {
        token: localStorage.token || "mVYUzIuJCAmoOjgiI0xaaW8mfqJGPq",
        "X-CSRF-Token": sessionStorage.token,
        "request-id": Util.getUID()
      };
    },
    restValid() {
      this.$refs.ruleForm.validateField("address");
    },
    selectedChange() {
      this.checked = false;
      if (
        this.ruleForm.enterpriseCategoryId == 2 ||
        this.ruleForm.enterpriseCategoryId == 4 ||
        this.ruleForm.enterpriseCategoryId == 5
      ) {
        this.showCheck = true;
      } else {
        this.showCheck = false;
      }
      this.ruleForm.licenseCode = "";
      this.ruleForm.permit = "";
      this.ruleForm.ZZJG = "";
      this.imgUrlJG = "";
      this.imgUrlSYXK = "";
      this.imgUrlLSXK = "";
      this.imgUrlYY = "";
      // this.imgUrlWT = "";
      // this.imgUrlSEAL = "";

      imageMap = {
        imgUrlJG: "",
        imgUrlSYXK: "",
        imgUrlLSXK: "",
        imgUrlYY: ""
        // imgUrlWT: "",
        // imgUrlSEAL: "",
        // imageUrlh: "",
        // imageUrlz: "",
        // imageUrlf: ""
      };
      this.$forceUpdate();
    },
    changeChecked() {
      if (!this.checked) {
        this.ZZJG = "";
      }
    },
    getDic() {
      BaseApi.createRpcToken(" /user/getIndustry")
        .then(
          data => {
            // console.log(data);
            this.options = data.datas.industryList;
            this.units = data.datas.categoryList;
          },
          data => {
            // console.log(data);
          }
        )
        .catch(function(e) {
          errorLog(e);
        });
    },
    lookExampleFn(num, x, y) {},

    closeExampleFn(num) {
      $(".exampleBox").css("display", "none");
    },
    realTrue() {
      // this.isSubFlag=false;
      $(".subMit").trigger("click");
    },
    //经办人信息下一步按钮
    nextStep() {
      this.$refs.ruleForm2.validate(valid => {
        if (valid) {
          if (this.legalPersonType == "2") {
            this.$refs.ruleForm3.validate(valid => {
              if (valid) {
                $(".sunCard").trigger("click");
              }
            });
          } else {
            $(".sunCard").trigger("click");
          }
        } else {
          return false;
        }
      });
    },
    //关闭人脸识别弹框
    closePassword(flag) {
      this.signing = flag;
    },
    lastStepFn() {
      $(".threeSteps li")
        .eq(2)
        .find("span")
        .removeClass("stepWalks");
      $(".enterpriseStep")
        .eq(1)
        .removeClass("stepWalks");
      $(".enterpriseStep")
        .eq(1)
        .siblings("p")
        .removeClass("stepWalks");
      this.uploadFirst = true;
      this.uploadSecond = false;
    },
    handlerSuccessUploadImgUrlJG(res, file) {
      this.handlerSuccessUpload(res, file, "imgUrlJG");
    },
    handlerSuccessUploadImgUrlSYXK(res, file) {
      this.handlerSuccessUpload(res, file, "imgUrlSYXK");
    },
    handlerSuccessUploadImgUrLSYXK(res, file) {
      this.handlerSuccessUpload(res, file, "imgUrlLSXK");
    },
    handlerSuccessUploadImgUrlYY(res, file) {
      this.handlerSuccessUpload(res, file, "imgUrlYY");
    },
    // handlerSuccessUploadImgUrlWT(res, file) {
    //   this.handlerSuccessUpload(res, file, "imgUrlWT");
    // },
    // handlerSuccessUploadImgUrlSEAL(res, file) {
    //   this.handlerSuccessUpload(res, file, "imgUrlSEAL");
    // },
    // handlerSuccessUploadImageUrlh(res, file) {
    //   this.handlerSuccessUpload(res, file, "imageUrlh");
    // },
    // handlerSuccessUploadImageUrlz(res, file) {
    //   this.handlerSuccessUpload(res, file, "imageUrlz");
    // },
    // handlerSuccessUploadImageUrlf(res, file) {
    //   this.handlerSuccessUpload(res, file, "imageUrlf");
    // },
    // handlerSuccessUpload(res, file, currentUrl) {
    //   if (
    //     file.raw.type.indexOf("image/jpg") ||
    //     file.raw.type.indexOf("image/png") ||
    //     file.raw.type.indexOf("image/jpeg")
    //   ) {
    //     this[currentUrl] = res.datas.fileUrl;
    //     imageMap[currentUrl] = res.datas.filePath;
    //   } else {
    //     this[currentUrl] = false;
    //   }
    // },
    handlerSuccessUploadImgUrlWTs(res, file) {
      if (
        file.raw.type.indexOf("image/jpg") ||
        file.raw.type.indexOf("image/png") ||
        file.raw.type.indexOf("image/jpeg")
      ) {
        this.imgUrlWTs = res.datas.fileUrl;
        this.imgUrlWTsFilePath = res.datas.filePath;
        this.imgUrlWTsLd = false;
      } else {
        this.imgUrlWTs = false;
      }
    },
    beforeUploadImgUrlWTs(file) {
      this.beforeAvatarUploadc(file, "imgUrlWTsLd");
    },
    handlerErrorUploadImgUrlWTs(res, file) {
      this.imgUrlWTsLd = false;
    },
    handlerErrorUploadImgUrlJG(res, file) {
      this.imgUrlJGLd = false;
    },
    handlerErrorUploadImgUrlSYXK(res, file) {
      this.imgUrlSYXKLd = false;
    },
    handlerErrorUploadImgUrLSYXK(res, file) {
      this.imgUrlLSXKLd = false;
    },
    handlerErrorUploadImgUrlYY(res, file) {
      this.imgUrlYYLd = false;
    },
    handlerErrorUploadImgUrlWT(res, file) {
      this.imgUrlWTLd = false;
    },
    handlerErrorUploadImgUrlSEAL(res, file) {
      this.imgUrlSEALLd = false;
    },
    handlerErrorUploadImageUrlh(res, file) {
      this.imageUrlhLd = false;
    },
    handlerErrorUploadImageUrlz(res, file) {
      this.imageUrlzLd = false;
    },
    handlerErrorUploadImageUrlf(res, file) {
      this.iimageUrlfLd = false;
    },

    beforeUploadImgUrlJG(file) {
      this.beforeAvatarUploadc(file, "imgUrlJGLd");
    },
    beforeUploadImgUrlSYXK(file) {
      this.beforeAvatarUploadc(file, "imgUrlSYXKLd");
    },
    beforeUploadImgUrLSYXK(file) {
      this.beforeAvatarUploadc(file, "imgUrlLSXKLd");
    },
    beforeUploadImgUrlYY(file) {
      this.beforeAvatarUploadc(file, "imgUrlYYLd");
    },
    beforeUploadImgUrlWT(file) {
      this.beforeAvatarUploadc(file, "imgUrlWTLd");
    },
    beforeUploadImgUrlSEAL(file) {
      this.beforeAvatarUploadc(file, "imgUrlSEALLd");
    },
    beforeUploadImageUrlh(file) {
      this.beforeAvatarUploadc(file, "imageUrlhLd");
    },
    beforeUploadImageUrlz(file) {
      this.beforeAvatarUploadc(file, "imageUrlzLd");
    },
    beforeUploadImageUrlf(file) {
      this.beforeAvatarUploadc(file, "imageUrlfLd");
    },

    handlerSuccessUpload(res, file, currentUrl) {
      const isPNG = file.raw.type === "image/png";
      const isJPEG = file.raw.type === "image/jpeg";
      const isJPG = file.raw.type === "image/jpg";
      if (!isJPG && !isPNG && !isJPEG) {
      } else {
        this[currentUrl + "Ld"] = false;
        this[currentUrl] = res.datas.fileUrl;
        imageMap[currentUrl] = res.datas.filePath;
      }
    },

    beforeAvatarUploadc(file, flag) {
      const isPNG = file.type === "image/png";
      const isJPEG = file.type === "image/jpeg";
      const isJPG = file.type === "image/jpg";
      const isLt5M = file.size / 1024 / 1024 < 5;
      // console.log(file);
      if (!isJPG && !isPNG && !isJPEG) {
        this.$message.error("上传的图片只能是jpg,jpeg,png格式!");
      }
      if (!isLt5M) {
        this.$message.error("上传的图片大小不能超过5MB!");
      }
      let isCanUpload = (isJPG || isPNG || isJPEG) && isLt5M;
      if (isCanUpload) {
        this[flag] = true;
      }
      return isCanUpload;
    },
    downLoad(url) {
      var elemIF = document.createElement("iframe");
      elemIF.src = url;
      elemIF.style.display = "none";
      document.body.appendChild(elemIF);
    },
    judgeImageUploads() {
      if (!this.imgUrlWTs) {
        //!this.imgUrlWT ||
        this.$message.error("请上传委托书");
        return false;
      }
      return true;
    },
    judgeImageUpload(id) {
      if (id == 1 || id == 3) {
        if (!this.imgUrlJG) {
          //!this.imgUrlWT ||  || !this.imgUrlSEAL
          this.$message.error("请上传全部认证所需要的文件");
          return false;
        }
      } else if (id == 2) {
        if (this.checked) {
          if (!this.imgUrlSYXK) {
            //|| !this.imgUrlWT || !this.imgUrlSEAL
            this.$message.error("请上传全部认证所需要的文件");
            return false;
          }
        } else {
          if (!this.imgUrlJG || !this.imgUrlSYXK) {
            //!this.imgUrlWT || !this.imgUrlSEAL
            this.$message.error("请上传全部认证所需要的文件");
            return false;
          }
        }
      } else if (id == 5) {
        if (this.checked) {
          if (!this.imgUrlLSXK) {
            //|| !this.imgUrlWT  || !this.imgUrlSEAL
            this.$message.error("请上传全部认证所需要的文件");
            return false;
          }
        } else {
          if (!this.imgUrlJG || !this.imgUrlLSXK) {
            //!this.imgUrlWT ||  !this.imgUrlSEAL
            this.$message.error("请上传全部认证所需要的文件");
            return false;
          }
        }
      } else if (id == 4) {
        if (this.checked) {
          if (!this.imgUrlYY) {
            //|| !this.imgUrlWT || !this.imgUrlSEAL
            this.$message.error("请上传全部认证所需要的文件");
            return false;
          }
        } else {
          if (!this.imgUrlJG || !this.imgUrlYY) {
            //!this.imgUrlWT || !this.imgUrlSEAL
            this.$message.error("请上传全部认证所需要的文件");
            return false;
          }
        }
      } else {
        // if (!this.imageUrlh || !this.imageUrlz || !this.imageUrlf) {
        //   this.$message.error("请上传全部认证所需要的文件");
        //   return false;
        // }
      }
      return true;
    },
    submitForm(formName) {
      this.isSubFlag = false;
      this.$refs[formName].validate(valid => {
        if (
          valid &&
          this.judgeImageUpload(this.ruleForm.enterpriseCategoryId)
        ) {
          this.$store.commit("showLoading", true);
          var params = {
            enterpriseName: this.ruleForm.enterpriseName,
            enterpriseIndustryId: this.ruleForm.enterpriseIndustryId,
            enterpriseCategoryId: this.ruleForm.enterpriseCategoryId,
            licenseCode: this.ruleForm.licenseCode,
            organizationCode: this.ruleForm.ZZJG,
            permit: this.ruleForm.permit,
            enterpriseAddress: this.ruleForm.enterpriseAddress,
            areaName: this.ruleForm.address[2],
            provinceName: this.ruleForm.address[0],
            cityName: this.ruleForm.address[1],
            postCode: this.ruleForm.postCode,
            enterprisePhone: this.ruleForm.enterprisePhone,
            enterpriseFax: this.ruleForm.enterpriseFax,
            
            organizationCodeWatermarkedPath: imageMap["imgUrlJG"],
            // powerOfAttorneyWatermarkedPath: imageMap["imgUrlWT"],
            // enterpriseSealWatermarkedPath: imageMap["imgUrlSEAL"],
            licenseWatermarkedPath: imageMap["imgUrlYY"],
            permitWatermarkedPath:
              imageMap["imgUrlSYXK"] || imageMap["imgUrlLSXK"],
            licenceUnited: this.checked ? 1 : 0,
            id: this.curinfos.id ? this.curinfos.id : this.enterpriseid
          };
          this.enterpriseParams = params;
          this.isSubFlag = true;
           BaseApi.createRpcToken(
            "/user/v2/enterpriseAuthentication",
            this.enterpriseParams,
            "post"
          )
            .then(
              data => {
                this.$store.commit("showLoading", false);
                  if (data.datas.code == 200) {
                    this.enterpriseid = data.datas.id;
                  localStorage.setItem("enterpriseId", data.datas.id);
                    $(".threeSteps li")
                      .eq(2)
                      .find("span")
                      .addClass("stepWalks");
                    $(".enterpriseStep")
                      .eq(1)
                      .addClass("stepWalks");
                    $(".enterpriseStep")
                      .eq(1)
                      .siblings("p")
                      .addClass("stepWalks");
                    this.uploadFirst = false;
                    this.getEnterpriseUser();
                    $(".enterpriseBox").animate({ scrollTop: 0 }, 1);
                    this.uploadSecond = true;
                  }
                },
              data => {
                this.$store.commit("showLoading", false);
              }
            )
            .catch(function(e) {
              errorLog(e);
            });
        } else {
          this.isSubFlag = true;
          return false;
        }
      });
    },
    closeDialog(data) {
      // console.log(data);
      this.CheckingInformation = data;
      this.hintBoxCon = data;
    },
    subCard(formName) {
      this.$store.commit("showLoading", true);
      let url = "/user/v2/saveLegalPerson",
        flag = "";
      let params={};
      // this.$refs[formName].validate(valid => {
      // if (this.legalPersonType == "1") {
      //   //法人代表
      //   params = {
      //     powerOfAttorneyWatermarkedPath: this.imgUrlWTsFilePath,
      //     legalPersonName: this.ruleForm2.legalPersonName,
      //     legalPersonMoblie: this.ruleForm2.legalPersonMoblie,
      //     legalPersonIdcardNumber: this.ruleForm2.legalPersonIdcardNumber,
      //     code: this.ruleForm2.code,
      //     operatorType: this.legalPersonType,
      //     nation: this.ruleForm3.nationality,
      //     idType: this.ruleForm3.regionType,
      //     sex: this.ruleForm3.usersex,
      //     birthDate: this.ruleForm3.birthDate,
      //     expiryDate: this.ruleForm3.dataEnd,
      //     legalPersonPost: this.ruleForm2.legalPersonPost,
      //   };
      // } else if (this.judgeImageUploads()) {
      //   //选择受委托人  - 法人信息
      //   params = {
      //     powerOfAttorneyWatermarkedPath: this.imgUrlWTsFilePath,
      //     legalPersonName: this.ruleForm3.legalPersonName,
      //     legalPersonMoblie: this.ruleForm3.legalPersonMoblie,
      //     legalPersonIdcardNumber: this.ruleForm3.regionType == '1'?this.ruleForm3.legalPersonIdcardNumber:this.ruleForm3.cardID,
      //     legalPersonPost: this.ruleForm3.legalPersonPosition,
      //     nation: this.ruleForm3.nationality,
      //     idType: this.ruleForm3.regionType,
      //     sex: this.ruleForm3.usersex,
      //     birthDate: this.ruleForm3.birthDate,
      //     expiryDate: this.ruleForm3.dataEnd,
      //     legalPersonPost: this.ruleForm3.cardID,
      //   };
      //   //受委托人信息
      //   params.adminPersonIdtype=this.ruleForm2.regionType;//证件类型
      //   params.adminPersonSex=this.ruleForm2.usersex;//性别
      //   params.code=this.ruleForm2.code;//验证码
      //   params.operatorType=this.legalPersonType,//法人-受托人
      //   params.adminPersonBirthDate=this.ruleForm2.birthDate;//出生日期
      //   params.adminPersonExpiryDate=this.ruleForm2.dataEnd;//证件有效期
      //   params.adminPersonNation=this.ruleForm2.nationality;//国籍
      //   params.adminPersonName = this.ruleForm2.legalPersonName;
      //   params.adminPersonMoblie = this.ruleForm2.legalPersonMoblie;
      //   params.adminPersonIdcardNumber=this.ruleForm2.regionType == '1'?this.ruleForm2.legalPersonIdcardNumber:this.ruleForm2.cardID;//证件号
      //   params.adminPersonPost = this.ruleForm2.legalPersonPost;
      // }
      // params.id=this.enterpriseid;//企业主键id
      // this.legalPersonParams=params;//法人参数
      if (!this.legalPersonType == "1") {
        if(!this.judgeImageUploads()){
          return;
        } 
      }
      flag = this.$route.query.flag;
      if (this.codeStatus == 0) {
        $(".threeSteps li")
          .eq(4)
          .find("span")
          .addClass("stepWalks");
        $(".threeSteps li")
          .eq(6)
          .find("span")
          .addClass("stepWalks");
        $(".enterpriseStep")
          .eq(2)
          .addClass("stepWalks");
        $(".enterpriseStep")
          .eq(2)
          .siblings("p")
          .addClass("stepWalks");
        this.uploadSecond = false;
        this.uploadthree = true;
      } else {
        this.userID = this.enterpriseid;
        if (this.enterpriseid) {
          this.signing = true;
          //获取二维码
          this.getFaceAuthOrderNo();
        }
      }
    },
    getCode() {
      let reg = /^((13[0-9])|(15[0-9])|(14[^4,\\D])|(16[0-9])|(17[0-9])|(18[0-9])||(19[8,9]))\d{8}$/;
      if (
        this.ruleForm2.legalPersonMoblie != "" &&
        reg.test(this.ruleForm2.legalPersonMoblie)
      ) {
        var queryStrs = {
          mobile: this.ruleForm2.legalPersonMoblie
        };
        BaseApi.createRpcToken("/common/getAuthenticationCode", queryStrs)
          .then(
            data => {
            },
            data => {
            }
          )
          .catch(function(e) {
            errorLog(e);
          });
        this.sendAuthCode = false;
        this.auth_time = 60;
        var auth_timetimers = setInterval(() => {
          this.auth_time--;
          if (this.auth_time <= 0) {
            this.sendAuthCode = true;
            clearInterval(auth_timetimers);
          }
        }, 1000);
      } else {
        this.$refs.ruleForm2.validateField("legalPersonMoblie");
      }
    }
  },
  watch: {
    curinfos(data) {
      this.curinfos = data;
      this.getEnterprise();
    }
  }
};
</script>
<style lang="scss">
.success_face {
  width: 118px;
  height: 32px;
  background: rgba(174, 61, 74, 1);
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  margin: 0 auto;
  display: block;
  cursor: pointer;
}
.face_error_class {
  height: 100px;
  padding-top: 80px;
}
.rlsb {
  width: 100%;
  height: 340px;
  position: relative;
  padding-bottom: 10px;
  .erweima_errro {
    width: 160px;
    height: 160px;
    background: rgba(255, 255, 255, 0.78);
    position: absolute;
    top: 38px;
    left: 50%;
    margin-left: -80px;
    z-index: 99;
    text-align: center;
    padding-top: 60px;
    box-sizing: border-box;
    .error_title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(50, 50, 50, 1);
      margin-bottom: 12px;
    }
    .update_erweima {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000;
      cursor: pointer;
    }
  }
  .erweima_success {
    width: 200px;
    height: 200px;
    background: rgba(255, 255, 255, 0.78);
    position: absolute;
    top: 38px;
    left: 50%;
    margin-left: -100px;
    z-index: 99;
    text-align: center;
    padding-top: 45px;
    box-sizing: border-box;
    .success_desc {
      margin-bottom: 10px;
      margin-top: 3px;
      font-size: 13px;
    }
    .success_title {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: rgba(50, 50, 50, 1);
      // margin-top: -15px;
    }
    .success_update_erweima {
      font-size: 14px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(77, 175, 247, 1);
      cursor: pointer;
    }
    img {
      opacity: 1;
    }
  }
  .rlsb_title {
    color: #1890ff;
    margin: 20px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      display: inline-block;
      width: 8px;
      height: 1px;
      background: #1890ff;
      border: 0;
    }
  }
  .erweima {
    width: 200px;
    margin: 0 auto;
    height: 200px;
    img {
      width: 100%;
    }
  }
  .rlsb_desc {
    width: 100%;
    text-align: center;
    height: 40px;
    line-height: 40px;
    margin-top: 20px;
  }
}
.enterpriseBox {
  background: #eaedf1;
  width: 100%;
  box-sizing: border-box;
  height: 100%;
  overflow-y: scroll;
  .el-radio__input.is-checked .el-radio__inner {
    border-color: #e88078;
    background: #e88078;
  }
  .el-radio__input.is-checked + .el-radio__label {
    color: #969696;
  }
  .el-radio__inner:hover {
    border-color: #e88078;
  }
  .el-radio {
    color: #969696;
  }
  .termination {
    display: inline-block;
    margin-left: 10px;
  }
  .enterpriseMains {
    width: 100%;
    height: 100%;
    display: table;
    background: #fff;
    border-radius: 3px;
    padding: 20px;
    box-sizing: border-box;
    .threeSteps {
      width: 100%;
      height: 120px;
      border: 1px dashed #c8c8cc;
      margin-top: 40px;
      margin-bottom: 20px;
      padding: 34px 4%;
      box-sizing: border-box;
      li {
        float: left;
        height: 28px;
      }
      li:nth-child(2n-1) {
        width: calc((100% - 100px) / 3);
        position: relative;
        span {
          position: absolute;
          display: block;
          width: 100%;
          height: 4px;
          background: #fbeceb;
          top: 50%;
          margin-top: 2px;
        }
        .stepWalk {
          background: #e98880;
        }
      }
      li:nth-child(2n) {
        position: relative;
        .enterpriseStep {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          border: 2px solid #fbeceb;
          padding: 2px;
          background-color: #fff;
          margin: 0 5px;
          span {
            display: inline-block;
            width: 100%;
            height: 100%;
            line-height: 100%;
            text-align: center;
            background: #fbeceb;
            border-radius: 50%;
            font-size: 20px;
            font-weight: bolder;
            color: #fff;
            position: relative;
          }
          span::before {
            content: "";
            position: absolute;
            width: 8px;
            height: 14px;
            color: #fff;
            border-bottom: 2px solid;
            border-right: 2px solid;
            top: 50%;
            margin-top: -4px;
            transform-origin: center;
            transform: translate(-50%, -30%) rotate(45deg);
            -webkit-transform: translate(-50%, -30%) rotate(45deg);
          }
        }
        p {
          position: absolute;
          left: 50%;
          width: 98px;
          bottom: -30px;
          font-size: 14px;
          color: #969696;
          text-align: center;
          margin-left: -49px;
        }
        div.stepWalk {
          border-color: #e98880;
          span {
            background: #e98880;
          }
        }
        p.stepWalk {
          color: #505050;
        }
      }
    }
    .uploadFilesBox {
      width: 100%;
      padding: 28px;
      display: table;
      border: 8px solid #f5f5f5;
      box-sizing: border-box;
      .filesHead {
        width: 100%;
        display: table;
        padding-bottom: 18px;
        border-bottom: 1px dashed #eb918a;
        li {
          float: left;
          color: #e88078;
          font-family: PingFangSC-Medium;
          line-height: 18px;
        }
        li:first-child {
          display: block;
          width: 4px;
          height: 18px;
          background: #e88078;
          margin-right: 10px;
          border-radius: 4px;
        }
        li:nth-child(3) {
          float: right;
          color: #3c3c3c;
          span {
            color: #e88078;
            vertical-align: middle;
            margin-right: 3px;
          }
        }
      }
      .filesContent {
        width: 100%;
        height: 323px;
        padding: 37px 122px 40px 122px;
        box-sizing: border-box;
        overflow: hidden;
        display: flex;
        justify-content: space-around;
        .uploadItem {
          width: 194px;
          dt {
            background: #f5f5f5;
            border: 1px solid #ebebeb;
            width: 192px;
            height: 130px;
            margin-bottom: 10px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          dd {
            .uploadBox {
              display: block;
              .uploadButton {
                border: 1px solid #d81212;
                width: 192px;
                height: 36px;
                line-height: 36px;
                font-size: 14px;
                color: #d81212;
                text-align: center;
                margin-bottom: 6px;
              }
            }
            .imgRuleDscp {
              font-size: 12px;
              color: #787878;
              text-align: left;
              margin-bottom: 6px;
            }
            .seeImgEx {
              font-size: 12px;
              color: #0291ff;
              cursor: pointer;
              text-align: left;
            }
          }
        }
        .filesConMain {
          display: flex;
          justify-content: space-around;
          width: 100%;
          padding-top: 26px;
          margin: 0 auto;
          dl {
            dt {
              font-family: "PingFangSC-Medium";
              color: #0291ff;
            }
            dd:nth-child(2) {
              width: 298px;
              height: 190px;
              border: 1px dashed #b4b4b4;
              margin: 8px 0;
              position: relative;
              display: flex;
              justify-content: center;
              align-items: center;
              .avatar-uploader {
                height: 100%;
                width: 100%;
                .avatar {
                  width: 100%;
                  height: 190px;
                  position: relative;
                }
                // .avatar-uploader-icon {
                //   position: absolute;
                //   left: 50%;
                //   right: 50%;
                //   transform: translateX(-50%);
                // }
                .el-upload {
                  display: flex;
                  height: 100%;
                  width: 100%;
                  align-items: center;
                  justify-content: center;
                }
                .el-icon-plus {
                  line-height: 190px;
                }
                .el-icon-plus:before {
                  content: "";
                  display: block;
                  height: 58px;
                  width: 58px;
                  background: url("../../../assets/images/enterprise/addfile_icon.png")
                    no-repeat;
                  background-size: 58px 58px;
                }
              }
              .addUploadCard {
                width: 48px;
                height: 48px;
                position: absolute;
                z-index: 2;
              }
              .aginFile {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                display: none;
                pointer-events: none;
                z-index: 3;
                img {
                  width: 100%;
                  height: 100%;
                }
              }
              .backJing {
                position: absolute;
                left: 0;
                right: 0;
                width: 100%;
                height: 100%;
                z-index: 1;
              }
            }
            dd:last-child {
              font-family: "PingFangSC-Medium";
              color: #646464;
            }
            .maskFile:hover {
              background: rgba(230, 230, 230, 0.5);
            }
          }
          dl:nth-child(2) {
            dd:nth-child(2) {
              width: 190px;
            }
          }
          #upCard {
            display: none;
          }
        }
        .idCard {
          .avatar-uploader {
            z-index: 2;
            .el-icon-plus:before {
              content: "";
              display: block;
              height: 58px;
              width: 58px;
              background: url("../../../assets/images/enterprise/Uploadcard_icon_nor.png ")
                no-repeat !important;
              background-size: cover !important;
            }
          }
        }
      }
      .fillInBox {
        // width: 438px;
        min-width: 554px;
        display: table;
        padding-top: 41px;
        margin: 0 auto;
        .el-form {
          .el-input__icon {
            line-height: 35px;
          }
          .el-form-item__label {
            width: 135px !important;
            padding: 0;
          }
          .el-form-item__content {
            line-height: 36px;
            margin-left: 135px !important;
            .el-input__inner {
              height: 36px;
              line-height: 36px;
              border-radius: 0;
              width: 329px;
              padding-left: 10px;
            }
            .el-input--prefix .el-input__inner{
              padding-left: 30px;
            }
          }
          .area-select.large {
            width: 329px;
          }
          .area-select {
            border-radius: 0;
            height: 36px;
          }
          .area-selected-trigger {
            padding: 0 0 0 10px;
          }
          .codeBox {
            .el-input {
              width: 200px;
            }
            .el-input__inner {
              width: 200px;
            }
            .code {
              display: inline-block;
              margin-left: 17px;
              cursor: pointer;
              width: 110px;
              height: 34px;
              line-height: 34px;
              border: 1px solid #e29999;
              color: #969696;
              font-family: "PingFangSC-Medium";
              text-align: center;
              cursor: pointer;
            }
          }
        }
        .items {
          .item {
            height: 36px;
            line-height: 36px;
            margin-bottom: 10px;
          }
        }
        .items:nth-child(1) {
          width: 118px;
          text-align: right;
        }
        .items:nth-child(2) {
          width: 320px;
          .item {
            width: 100%;
            padding-left: 10px;
            box-sizing: border-box;
            border: 1px solid #c8c8c8;
            input {
              width: 100%;
              height: 100%;
            }
            .el-select {
              width: 320px;
              .el-input {
                height: 34px;
                line-height: 34px;
              }
            }
          }
          .item:nth-child(2),
          .item:nth-child(3) {
            .el-input__inner {
              border-radius: 0;
              padding-left: 10px;
              border-color: #c8c8c8;
            }
            .el-select-dropdown__item.selected {
              color: #606266;
            }
            .el-input__suffix {
              top: 4px;
            }
          }
          .item:nth-child(5) {
            padding-left: 0;
            border: none;
            .area-cascader-wrap {
              .area-select {
                width: 320px;
                height: 36px;
                margin-left: 0;
                .area-selected-trigger {
                  padding: 0 0 0 10px;
                }
              }
            }
          }
        }
      }
    }
    .uploadFilesBoxTwo {
      // .filesContent{
      //   .filesConMain{
      //     dl:nth-child(1){
      //     dd:nth-child(2){
      //     // background:url("../../../assets/images/enterprise/back01_img.png");
      //     }
      //     }
      //   }
      // }

      dd:nth-child(2):hover .addUploadCard {
        background: url("../../../assets/images/enterprise/Uploadcard_icon_hov_pre.png")
          no-repeat center center;
        background-size: 48px 48px;
      }
      .filesContent {
        width: 100%;
        height: 323px;
        padding: 37px 122px 40px 122px;
        box-sizing: border-box;
        overflow: hidden;
        display: flex;
        justify-content: space-around;
        .uploadItem {
          width: 194px;
          dt {
            background: #f5f5f5;
            border: 1px solid #ebebeb;
            width: 192px;
            height: 130px;
            margin-bottom: 10px;
            img {
              width: 100%;
              height: 100%;
            }
          }
          dd {
            .uploadBox {
              display: block;
              .uploadButton {
                border: 1px solid #d81212;
                width: 192px;
                height: 36px;
                line-height: 36px;
                font-size: 14px;
                color: #d81212;
                text-align: center;
                margin-bottom: 6px;
              }
            }
            .imgRuleDscp {
              font-size: 12px;
              color: #787878;
              text-align: left;
              margin-bottom: 6px;
            }
            .seeImgEx {
              font-size: 12px;
              color: #0291ff;
              cursor: pointer;
              text-align: left;
            }
          }
        }
      }
    }
    #uploadFilesBox {
      .item:nth-child(2),
      .item:nth-child(3) {
        padding-left: 0;
        border: 0;
      }
    }
    .completeBox {
      dl {
        img {
          width: 48px;
          height: 48px;
        }
        dd:nth-child(2) {
          color: #646464;
          font-family: "PingFangSC-Medium";
          margin: 20px 0;
        }
        dd:nth-child(3) {
          color: #969696;
          font-family: "PingFangSC-Medium";
        }
      }
    }
    .enterpriseFoot {
      width: 100%;
      display: table;
      padding-top: 30px;
      padding-bottom: 40px;
      button {
        display: inline-block;
        width: 160px;
        height: 40px;
        line-height: 40px;
        color: #db4437;
        border: 1px solid #db4437;
        cursor: pointer;
      }
      button:nth-child(2n-1) {
        margin-right: 60px;
      }
      button:nth-child(2) {
        background-color: #db4437;
        color: #fff;
      }
      button:hover {
        background: #a5303d;
        color: #fff;
      }
      span {
        display: inline-block;
        width: 160px;
        height: 40px;
        line-height: 40px;
        color: #db4437;
        border: 1px solid #db4437;
        cursor: pointer;
      }
      span:nth-child(2n-1) {
        margin-right: 60px;
      }
      span:nth-child(2) {
        background-color: #db4437;
        color: #fff;
      }
      span:hover {
        background: #a5303d;
        color: #fff;
      }
    }
  }
}
.exampleBox {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background: rgba(100, 100, 100, 0.5);
  z-index: 1000;
  .conentExamp {
    text-align: center;
    position: relative;
    vertical-align: middle;
    position: absolute;
    left: 50%;
    margin-top: 170px;
    transform: translate(-50%, 0);
    span {
      height: 100%;
      vertical-align: middle;
      display: inline-block;
    }
    .conentImg {
      vertical-align: middle;
    }
    b {
      position: absolute;
      right: -5%;
      top: -4%;
      display: block;
      color: #fff;
      width: 20px;
      height: 20px;
      line-height: 20px;
      border-radius: 50%;
    }
  }
  .conentExamp:nth-child(2) {
    width: 500px;
    height: 340px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin-top: -170px;
    margin-left: -250px;
    .conentImg {
      width: 100%;
      height: 100%;
      vertical-align: middle;
    }
  }
}
.errorBox {
  width: 100%;
  height: calc(100% - 80px);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  h3 {
    font-size: 24px;
    color: #6f6f6f;
    margin: 14px 0;
  }
  p {
    font-size: 16px;
    color: #6f6f6f;
    span {
      display: inline-block;
      border: 1px solid #db4437;
      width: 160px;
      height: 40px;
      text-align: center;
      line-height: 40px;
      font-size: 16px;
      color: #db4437;
      margin-top: 30px;
    }
    span:hover {
      color: #fff;
      font-weight: normal;
      background-color: #a5303d;
    }
  }
}
.search_nation_box{
    position: absolute;
    top:0px;
    left: 0px;
    z-index: 99;
    width: 100%;
    background: #fff;
    padding-top: 10px;
    
}
 .search_nation{
    width:89%;
    height: 34px;
    border-radius: 3px;
    background: #F2F2F2;
    margin:0 auto;
    line-height: 34px;
    img{
      width:14px;
      margin-left: 20px;
      float: left;
      margin-top: 12px;
    }
    input{
      font-size: 14px;
      margin-left: 5px;
    }
    input::placeholder{
      color:#9F9F9F;
    }
  }
  .search_nation_p{
     .el-input.el-input--suffix .el-input__inner{
        height:36px!important;
      }
     .el-input.is-disabled .el-input__inner{
        background: #fff;
      }
  }
.el-input.is-disabled .el-input__inner {
  background-color: #fff;
  border-color: #e4e7ed;
  color: #606266;
}
.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #db4437;
  border-color: #db4437;
}
.el-checkbox__inner:hover {
  border-color: #db4437;
}
.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #e4e7ed;
}
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #db4437;
}
</style>

